import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKulturpunktAuto = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 36.283 35.002",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "KulturPunkt_Auto",
		transform: "translate(-1399.878 -711.003)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "K",
			transform: "translate(1425.986 721.958)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_18",
					"data-name": "Rectangle 18",
					width: 4.368,
					height: 24.047,
					transform: "translate(-9.484)"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_2",
					"data-name": "Path 2",
					d: "M-4746.584,3067l-8.686,11.834,7.03,12.116h-5.2l-7.245-12.116,8.616-11.834Z",
					transform: "translate(4756.243 -3066.946)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle_19",
					"data-name": "Rectangle 19",
					width: 4.368,
					height: 24.047,
					transform: "translate(-10)"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12",
					"data-name": "Path 12",
					d: "M-4746.584,3067l-8.686,11.834,7.03,12.116h-5.2l-7.245-12.116,8.616-11.834Z",
					transform: "translate(4756.758 -3066.946)"
				})
			]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_3188",
			"data-name": "Group 3188",
			transform: "translate(4.209 232.297)",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "magic_button_FILL0_wght300_GRAD0_opsz48",
				d: "M571.778-418.965l-1.9-4.27-4.259-1.909,4.252-1.938,1.911-4.225,1.955,4.225,4.225,1.938-4.227,1.909Z",
				transform: "translate(830.053 917.867)"
			}), /* @__PURE__ */ _jsx("path", {
				id: "magic_button_FILL0_wght300_GRAD0_opsz48-2",
				"data-name": "magic_button_FILL0_wght300_GRAD0_opsz48",
				d: "M570.036-422.455l-1.366-3.063-3.055-1.37,3.05-1.39,1.371-3.03,1.4,3.03,3.03,1.39-3.032,1.37Z",
				transform: "translate(837.969 910.014)"
			})]
		})]
	})
});
export default SvgKulturpunktAuto;
